// extracted by mini-css-extract-plugin
module.exports = {"cardNoPadding":"DocumentManagerTabItem_cardNoPadding__3e2dL","searchBarContainer":"DocumentManagerTabItem_searchBarContainer__H8sA1"};